"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e={name:"embeds",sanitizeSchema:{tagNames:["iframe"],attributes:{iframe:["src","width","height","frameBorder","allowFullScreen","allow","title"]}}};exports.embeds=e;
//# sourceMappingURL=index.cjs.map
